import { render, staticRenderFns } from "./Indigo.vue?vue&type=template&id=85489676&"
import script from "./Indigo.vue?vue&type=script&lang=js&"
export * from "./Indigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports